import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue';
import InstructionPage from './views/InstructionPage.vue';
import QuestionSet from './views/QuestionSet.vue';

Vue.use(Router);

export default new Router({
    mode: 'history',
    routes: [
        {  path: '/:surveyId/ins/:lang/:itemId', name: 'instruction', component: InstructionPage },
        {  path: '/:surveyId/set/:lang/:itemId', name: 'questionSet', component: QuestionSet },
        {  path: '/:surveyId/:lang', name: 'home', component: Home }
    ]
})